import { render, staticRenderFns } from "./KauLogin.vue?vue&type=template&id=95d08300&scoped=true"
import script from "./KauLogin.vue?vue&type=script&lang=js"
export * from "./KauLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95d08300",
  null
  
)

export default component.exports